import { Company } from '@/class/model/mdm/Company'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { AirPort } from '@/class/model/mdm/AirPort'
import StrUtils from '@/utils/StrUtils'
import { getCacheListByKey, getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { getFileList } from '@/api/storage'
import { AirPortRequirement } from '@/class/model/mdm/AirPortRequirement'

export class AirCargoDocUtil {
  static currentJob = null
  // 根据目的港代理信息更新MBL，HBL信息
  static async checkAirOverseaAgentProperties(job) {
    this.currentJob = job
    if (job && job.destinationAgent > 0 && job.operateType !== AirExportConstants.DIRECT.code) {
      const destinationAgent = await Company.getCompanyById(job.destinationAgent)
      if (destinationAgent) {
        const overseaAgent = await new Company(destinationAgent).getOverseaAgentDetail()
        if (overseaAgent) {
          const mdoc = await new AirExportJob(job).getCargoDoc(CargoDocConsts.MAWB, false)
          if (mdoc) {
            mdoc.consigneeCode = ''
            if (overseaAgent.airAddressLine1) {
              mdoc.consigneeLine1 = overseaAgent.airAddressLine1
            }
            if (overseaAgent.airAddressLine2) {
              mdoc.consigneeLine2 = overseaAgent.airAddressLine2
            }
            if (overseaAgent.airAddressLine3) {
              mdoc.consigneeLine3 = overseaAgent.airAddressLine3
            }
            if (overseaAgent.airAddressLine4) {
              mdoc.consigneeLine4 = overseaAgent.airAddressLine4
            }
            if (overseaAgent.airAddressLine5) {
              mdoc.consigneeLine5 = overseaAgent.airAddressLine5
            }
            if (overseaAgent.airAddressLine6) {
              mdoc.consigneeLine6 = overseaAgent.airAddressLine6
            }
            if (overseaAgent.airAddressLine7) {
              mdoc.consigneeLine7 = overseaAgent.airAddressLine7
            }
            mdoc.notifyCode = ''
            if (overseaAgent.airNotifyAddressLine1) {
              mdoc.notifyLine1 = overseaAgent.airNotifyAddressLine1
            }
            if (overseaAgent.airNotifyAddressLine2) {
              mdoc.notifyLine2 = overseaAgent.airNotifyAddressLine2
            }
            if (overseaAgent.airNotifyAddressLine3) {
              mdoc.notifyLine3 = overseaAgent.airNotifyAddressLine3
            }
            if (overseaAgent.airNotifyAddressLine4) {
              mdoc.notifyLine4 = overseaAgent.airNotifyAddressLine4
            }
            if (overseaAgent.airNotifyAddressLine5) {
              mdoc.notifyLine5 = overseaAgent.airNotifyAddressLine5
            }
            if (overseaAgent.airNotifyAddressLine6) {
              mdoc.notifyLine6 = overseaAgent.airNotifyAddressLine6
            }
            if (overseaAgent.airNotifyAddressLine7) {
              mdoc.notifyLine7 = overseaAgent.airNotifyAddressLine7
            }
          }
          // CARGO-30742 空运出口：Handling info 设置成必填项
          // await this.changeHAWBAgentParty(job)
        }
      }
    }
  }
  // 如果一票业务的目的港代理和指定货代理不是同一家，HBL页面的代理信息应该取指定货代理信息
  static async changeHAWBAgentParty(job) {
    this.currentJob = job
    let agentId = (job.destinationAgent === 0 || job.destinationAgent === job.designationAgent) ? job.destinationAgent : job.designationAgent
    if (agentId === 0) {
      agentId = job.destinationAgent
    }
    if (agentId > 0) {
      const destinationAgent = await Company.getCompanyById(agentId)
      if (destinationAgent) {
        const overseaAgent = await new Company(destinationAgent).getOverseaAgentDetail()
        if (overseaAgent) {
          const hawb = await new AirExportJob(job).getCargoDoc(CargoDocConsts.HAWB, false)
          if (hawb) {
            if (overseaAgent.airAddressLine1) {
              hawb.handingInfo = destinationAgent.overseaAgentDetail.airAddressLine1 + '\n'
            }
            if (overseaAgent.airAddressLine2) {
              hawb.handingInfo += destinationAgent.overseaAgentDetail.airAddressLine2 + '\n'
            }
            if (overseaAgent.airAddressLine3) {
              hawb.handingInfo += destinationAgent.overseaAgentDetail.airAddressLine3 + '\n'
            }
            if (overseaAgent.airAddressLine4) {
              hawb.handingInfo += destinationAgent.overseaAgentDetail.airAddressLine4 + '\n'
            }
            if (overseaAgent.airAddressLine5) {
              hawb.handingInfo += destinationAgent.overseaAgentDetail.airAddressLine5 + '\n'
            }
            if (overseaAgent.airAddressLine6) {
              hawb.handingInfo += destinationAgent.overseaAgentDetail.airAddressLine6
            }
          }
        }
      }
    }
  }

  static async getAirportRequirement(job, type) {
    // 先把airportRequirement设置为空对象,匹配最新的港口需求
    let airportRequirement = null
    if (job) {
      const airportRequirementArray = getCacheListByKey(basicCacheKeys.basic_data_AirportRequirement)
      let newAirportRequirementArray = null
      if (airportRequirementArray != null) {
        newAirportRequirementArray = []
        for (const s3 of airportRequirementArray) {
          if (type === 'HAWB' && s3.hawb) {
            newAirportRequirementArray.push(s3)
          } else if (type === 'MAWB' && s3.mawb) {
            newAirportRequirementArray.push(s3)
          }
        }
        newAirportRequirementArray.sort((a, b) => {
          const suffixA = new Date(a.dateModified).getTime()
          const suffixB = new Date(b.dateModified).getTime()
          return suffixA - suffixB
        })
        let regionCode = null
        if (job.destinationPortCode) {
          const port = await AirPort.getAirportByCode(job.destinationPortCode)
          if (port) {
            regionCode = port.region
          }
        }
        // 起运港，卸货港，交货地，货物类型都是必填项，不需要判空
        const fullMatching = !StrUtils.isEmpty(regionCode) && job.carrierId > 0 && job.destinationAgent > 0
        if (fullMatching) {
          for (const s of newAirportRequirementArray) {
            if (s.cargoType === job.cargoType && s.carrierId === job.carrierId && s.destinationAgent === job.destinationAgent &&
                !StrUtils.isEmpty(s.loadingPortCodes) && s.loadingPortCodes.indexOf(job.loadingPortCode) >= 0 &&
                !StrUtils.isEmpty(s.dischargingPortCodes) && s.dischargingPortCodes.indexOf(job.dischargingPortCode) >= 0 &&
                !StrUtils.isEmpty(s.destinationPortCodes) && s.destinationPortCodes.indexOf(job.destinationPortCode) >= 0 &&
                !StrUtils.isEmpty(regionCode) && s.regions.indexOf(regionCode) >= 0) {
              airportRequirement = s
              break
            }
          }
        }
        if (!airportRequirement) {
          const conditionMap = {}
          const lDiDeCaList = []
          const lDiDeList = []
          const lDiCaList = []
          const lDeCaList = []
          const diDeCaList = []
          const lDiList = []
          const lDeList = []
          const lCaList = []
          const diDeList = []
          const diCaList = []
          const deCaList = []
          const lList = []
          const diList = []
          const deList = []
          const reList = []
          const caList = []
          // 空运的交货地是非必填项目，一般是目的港的英文名称，可以手动改。
          let destinationPlace = ''
          if (job.destinationPlace) {
            const airport = getObjectByCache(basicCacheKeys.basic_data_Airport, 'englishName', job.destinationPlace)
            if (airport) {
              destinationPlace = airport.code
            }
          }
          for (const s1 of newAirportRequirementArray) {
            // 优先匹配业务的必填项（起运港:loadingPortCode、卸货港:destinationPortCode、交货地:destinationPlace、货物类型:cargoType）
            if (!StrUtils.isEmpty(s1.loadingPortCodes) && s1.loadingPortCodes.indexOf(job.loadingPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.dischargingPortCodes) && s1.dischargingPortCodes.indexOf(job.destinationPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.destinationPortCodes) && destinationPlace && s1.destinationPortCodes.indexOf(destinationPlace) >= 0 &&
                !StrUtils.isEmpty(s1.cargoType) && s1.cargoType === job.cargoType) {
              lDiDeCaList.push(s1)
            } else if (!StrUtils.isEmpty(s1.loadingPortCodes) && s1.loadingPortCodes.indexOf(job.loadingPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.dischargingPortCodes) && s1.dischargingPortCodes.indexOf(job.destinationPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.destinationPortCodes) && destinationPlace && s1.destinationPortCodes.indexOf(destinationPlace) >= 0 &&
                StrUtils.isEmpty(s1.cargoType)) {
              lDiDeList.push(s1)
            } else if (!StrUtils.isEmpty(s1.loadingPortCodes) && s1.loadingPortCodes.indexOf(job.loadingPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.dischargingPortCodes) && s1.dischargingPortCodes.indexOf(job.destinationPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.cargoType) && s1.cargoType === job.cargoType &&
                StrUtils.isEmpty(s1.destinationPortCodes)) {
              lDiCaList.push(s1)
            } else if (!StrUtils.isEmpty(s1.loadingPortCodes) && s1.loadingPortCodes.indexOf(job.loadingPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.destinationPortCodes) && destinationPlace && s1.destinationPortCodes.indexOf(destinationPlace) >= 0 &&
                !StrUtils.isEmpty(s1.cargoType) && s1.cargoType === job.cargoType &&
                StrUtils.isEmpty(s1.dischargingPortCodes)) {
              lDeCaList.push(s1)
            } else if (!StrUtils.isEmpty(s1.dischargingPortCodes) && s1.dischargingPortCodes.indexOf(job.destinationPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.destinationPortCodes) && destinationPlace && s1.destinationPortCodes.indexOf(destinationPlace) >= 0 &&
                !StrUtils.isEmpty(s1.cargoType) && s1.cargoType === job.cargoType &&
                StrUtils.isEmpty(s1.loadingPortCodes)) {
              diDeCaList.push(s1)
            } else if (!StrUtils.isEmpty(s1.loadingPortCodes) && s1.loadingPortCodes.indexOf(job.loadingPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.dischargingPortCodes) && s1.dischargingPortCodes.indexOf(job.destinationPortCode) >= 0 &&
                StrUtils.isEmpty(s1.destinationPortCodes) && StrUtils.isEmpty(s1.cargoType)) {
              lDiList.push(s1)
            } else if (!StrUtils.isEmpty(s1.loadingPortCodes) && s1.loadingPortCodes.indexOf(job.loadingPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.destinationPortCodes) && destinationPlace && s1.destinationPortCodes.indexOf(destinationPlace) >= 0 &&
                StrUtils.isEmpty(s1.dischargingPortCodes) && StrUtils.isEmpty(s1.cargoType)) {
              lDeList.push(s1)
            } else if (!StrUtils.isEmpty(s1.loadingPortCodes) && s1.loadingPortCodes.indexOf(job.loadingPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.cargoType) && s1.cargoType === job.cargoType &&
                StrUtils.isEmpty(s1.dischargingPortCodes) && StrUtils.isEmpty(s1.destinationPortCodes)) {
              lCaList.push(s1)
            } else if (!StrUtils.isEmpty(s1.dischargingPortCodes) && s1.dischargingPortCodes.indexOf(job.destinationPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.destinationPortCodes) && destinationPlace && s1.destinationPortCodes.indexOf(destinationPlace) >= 0 &&
                StrUtils.isEmpty(s1.loadingPortCodes) && StrUtils.isEmpty(s1.cargoType)) {
              diDeList.push(s1)
            } else if (!StrUtils.isEmpty(s1.dischargingPortCodes) && s1.dischargingPortCodes.indexOf(job.destinationPortCode) >= 0 &&
                !StrUtils.isEmpty(s1.cargoType) && s1.cargoType === job.cargoType &&
                StrUtils.isEmpty(s1.destinationPortCodes) && StrUtils.isEmpty(s1.loadingPortCodes)) {
              diCaList.push(s1)
            } else if (!StrUtils.isEmpty(s1.destinationPortCodes) && destinationPlace && s1.destinationPortCodes.indexOf(destinationPlace) >= 0 &&
                !StrUtils.isEmpty(s1.cargoType) && s1.cargoType === job.cargoType &&
                StrUtils.isEmpty(s1.dischargingPortCodes) && StrUtils.isEmpty(s1.loadingPortCodes)) {
              deCaList.push(s1)
            } else if (!StrUtils.isEmpty(s1.loadingPortCodes) && s1.loadingPortCodes.indexOf(job.loadingPortCode) >= 0 &&
                StrUtils.isEmpty(s1.dischargingPortCodes) && StrUtils.isEmpty(s1.destinationPortCodes) && StrUtils.isEmpty(s1.cargoType)) {
              lList.push(s1)
            } else if (!StrUtils.isEmpty(s1.dischargingPortCodes) && s1.dischargingPortCodes.indexOf(job.destinationPortCode) >= 0 &&
                StrUtils.isEmpty(s1.loadingPortCodes) && StrUtils.isEmpty(s1.destinationPortCodes) && StrUtils.isEmpty(s1.cargoType)) {
              diList.push(s1)
            } else if (!StrUtils.isEmpty(s1.destinationPortCodes) && destinationPlace && s1.destinationPortCodes.indexOf(destinationPlace) >= 0 &&
                StrUtils.isEmpty(s1.loadingPortCodes) && StrUtils.isEmpty(s1.dischargingPortCodes) && StrUtils.isEmpty(s1.cargoType)) {
              deList.push(s1)
            } else if (!StrUtils.isEmpty(regionCode) && !StrUtils.isEmpty(s1.regions) && s1.regions.indexOf(regionCode) >= 0 && StrUtils.isEmpty(s1.loadingPortCodes) &&
                StrUtils.isEmpty(s1.dischargingPortCodes) && StrUtils.isEmpty(s1.destinationPortCodes)) { // 港口维护均为空时，航线不为空时，优先匹配航线
              reList.push(s1)
            } else if (!StrUtils.isEmpty(s1.cargoType) && s1.cargoType === job.cargoType &&
                StrUtils.isEmpty(s1.loadingPortCodes) && StrUtils.isEmpty(s1.dischargingPortCodes) && StrUtils.isEmpty(s1.destinationPortCodes)) {
              caList.push(s1)
            } else { // 必填项组合没有匹配到
              if (StrUtils.isEmpty(s1.loadingPortCodes) && StrUtils.isEmpty(s1.dischargingPortCodes) && StrUtils.isEmpty(s1.destinationPortCodes) && StrUtils.isEmpty(s1.cargoType)) {
                // 选填项（航线、船公司、目的港代理）--rdc
                if (!StrUtils.isEmpty(s1.regions) && !StrUtils.isEmpty(regionCode) && s1.regions.indexOf(regionCode) >= 0 &&
                    job.carrierId > 0 && s1.carrierId === job.carrierId &&
                    job.destinationAgent > 0 && s1.destinationAgent === job.destinationAgent) {
                  if (!conditionMap.hasOwnProperty('rdc')) {
                    conditionMap['rdc'] = s1
                  }
                } else if (!StrUtils.isEmpty(s1.regions) && !StrUtils.isEmpty(regionCode) && s1.regions.indexOf(regionCode) >= 0 &&
                    job.destinationAgent > 0 && s1.destinationAgent === job.destinationAgent &&
                    s1.carrierId === 0) {
                  if (!conditionMap.hasOwnProperty('rd')) {
                    conditionMap['rd'] = s1
                  }
                } else if (!StrUtils.isEmpty(s1.regions) && !StrUtils.isEmpty(regionCode) && s1.regions.indexOf(regionCode) >= 0 &&
                    job.carrierId > 0 && s1.carrierId === job.carrierId &&
                    s1.destinationAgent === 0) {
                  if (!conditionMap.hasOwnProperty('rc')) {
                    conditionMap['rc'] = s1
                  }
                } else if (job.destinationAgent > 0 && s1.destinationAgent === job.destinationAgent &&
                    job.carrierId > 0 && s1.carrierId === job.carrierId && StrUtils.isEmpty(s1.regions)) {
                  if (!conditionMap.hasOwnProperty('dc')) {
                    conditionMap['dc'] = s1
                  }
                } else if (!StrUtils.isEmpty(s1.regions) && !StrUtils.isEmpty(regionCode) && s1.regions.indexOf(regionCode) >= 0 &&
                    s1.carrierId === 0 && s1.destinationAgent === 0) {
                  if (!conditionMap.hasOwnProperty('r')) {
                    conditionMap['r'] = s1
                  }
                } else if (job.destinationAgent > 0 && s1.destinationAgent === job.destinationAgent &&
                    StrUtils.isEmpty(s1.regions) && s1.carrierId === 0) {
                  if (!conditionMap.hasOwnProperty('d')) {
                    conditionMap['d'] = s1
                  }
                } else if (job.carrierId > 0 && s1.carrierId === job.carrierId &&
                    StrUtils.isEmpty(s1.regions) && s1.destinationAgent === 0) {
                  if (!conditionMap.hasOwnProperty('c')) {
                    conditionMap['c'] = s1
                  }
                }
              }
            }
          }
          // 如果匹配到必填项，对必填项进行二次刷选出匹配的选填项目
          if (lDiDeCaList.length > 0) {
            airportRequirement = this.optionalSelect(lDiDeCaList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && lDiDeList.length > 0) {
            airportRequirement = this.optionalSelect(lDiDeList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && lDiCaList.length > 0) {
            airportRequirement = this.optionalSelect(lDiCaList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && lDeCaList.length > 0) {
            airportRequirement = this.optionalSelect(lDeCaList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && diDeCaList.length > 0) {
            airportRequirement = this.optionalSelect(diDeCaList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && lDiList.length > 0) {
            airportRequirement = this.optionalSelect(lDiList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && lDeList.length > 0) {
            airportRequirement = this.optionalSelect(lDeList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && lCaList.length > 0) {
            airportRequirement = this.optionalSelect(lCaList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && diDeList.length > 0) {
            airportRequirement = this.optionalSelect(diDeList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && diCaList.length > 0) {
            airportRequirement = this.optionalSelect(diCaList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && deCaList.length > 0) {
            airportRequirement = this.optionalSelect(deCaList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && lList.length > 0) {
            airportRequirement = this.optionalSelect(lList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && diList.length > 0) {
            airportRequirement = this.optionalSelect(diList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && deList.length > 0) {
            airportRequirement = this.optionalSelect(deList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && reList.length > 0) {
            airportRequirement = this.reListOptionalSelect(reList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && caList.length > 0) {
            airportRequirement = this.optionalSelect(caList, job, regionCode, conditionMap)
          }
          if (!airportRequirement && conditionMap.hasOwnProperty('rdc')) {
            airportRequirement = conditionMap['rdc']
          }
          if (!airportRequirement && conditionMap.hasOwnProperty('rd')) {
            airportRequirement = conditionMap['rd']
          }
          if (!airportRequirement && conditionMap.hasOwnProperty('rc')) {
            airportRequirement = conditionMap['rc']
          }
          if (!airportRequirement && conditionMap.hasOwnProperty('dc')) {
            airportRequirement = conditionMap['dc']
          }
          if (!airportRequirement && conditionMap.hasOwnProperty('r')) {
            airportRequirement = conditionMap['r']
          }
          if (!airportRequirement && conditionMap.hasOwnProperty('d')) {
            airportRequirement = conditionMap['d']
          }
          if (!airportRequirement && conditionMap.hasOwnProperty('c')) {
            airportRequirement = conditionMap['c']
          }
        }
        // 以上匹配不到的时候，取基础资料中只维护了港口要求和显示规则的记录
        if (!airportRequirement) {
          for (const s2 of newAirportRequirementArray) {
            if (StrUtils.isEmpty(s2.loadingPortCodes) && StrUtils.isEmpty(s2.dischargingPortCodes) && StrUtils.isEmpty(s2.destinationPortCodes) &&
                StrUtils.isEmpty(s2.cargoType) && StrUtils.isEmpty(s2.regions) && s2.destinationAgent === 0 && s2.carrierId === 0) {
              airportRequirement = s2
              break
            }
          }
        }
      }
    }
    if (!airportRequirement) {
      airportRequirement = new AirPortRequirement().fillDefaultValue().getData()
    }
    return airportRequirement
  }

  static reListOptionalSelect(list, job, regionCode, conditionMap) { // 港口维护均为空时，航线不为空时，要做特殊处理(此处优先级高于货物类型)
    list.sort((a, b) => {
      const suffixA = new Date(a.dateModified).getTime()
      const suffixB = new Date(b.dateModified).getTime()
      return suffixA - suffixB
    })
    let airportRequirement = null
    for (const s of list) {
      if (StrUtils.isEmpty(s.loadingPortCodes) && StrUtils.isEmpty(s.dischargingPortCodes) && StrUtils.isEmpty(s.destinationPortCodes)) {
        if (!StrUtils.isEmpty(s.regions) && s.regions.indexOf(regionCode) >= 0 && !StrUtils.isEmpty(s.cargoType) &&
            s.cargoType === job.cargoType && job.destinationAgent > 0 && s.destinationAgent === job.destinationAgent &&
            job.carrierId > 0 && s.carrierId === job.carrierId) {
          if (!conditionMap.hasOwnProperty('rcadc')) {
            conditionMap['rcadc'] = s
          }
        } else if (!StrUtils.isEmpty(s.regions) && s.regions.indexOf(regionCode) >= 0 && !StrUtils.isEmpty(s.cargoType) && s.cargoType === job.cargoType &&
            job.destinationAgent > 0 && s.destinationAgent === job.destinationAgent && s.carrierId === 0) {
          if (!conditionMap.hasOwnProperty('rcad')) {
            conditionMap['rcad'] = s
          }
        } else if (!StrUtils.isEmpty(s.regions) && s.regions.indexOf(regionCode) >= 0 && !StrUtils.isEmpty(s.cargoType) && s.cargoType === job.cargoType &&
            job.destinationAgent > 0 && job.carrierId > 0 && s.carrierId === job.carrierId && s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('rcac')) {
            conditionMap['rcac'] = s
          }
        } else if (!StrUtils.isEmpty(s.regions) && s.regions.indexOf(regionCode) >= 0 &&
            job.destinationAgent > 0 && s.destinationAgent === job.destinationAgent &&
            job.carrierId > 0 && s.carrierId === job.carrierId) {
          if (!conditionMap.hasOwnProperty('rdc')) {
            conditionMap['rdc'] = s
          }
        } else if (!StrUtils.isEmpty(s.regions) && s.regions.indexOf(regionCode) >= 0 && !StrUtils.isEmpty(s.cargoType) &&
            s.cargoType === job.cargoType && s.destinationAgent === 0 && s.carrierId === 0) {
          if (!conditionMap.hasOwnProperty('rca')) {
            conditionMap['rca'] = s
          }
        } else if (!StrUtils.isEmpty(s.regions) && !StrUtils.isEmpty(regionCode) && s.regions.indexOf(regionCode) >= 0 &&
            job.destinationAgent > 0 && s.destinationAgent === job.destinationAgent &&
            s.carrierId === 0) {
          if (!conditionMap.hasOwnProperty('rd')) {
            conditionMap['rd'] = s
          }
        } else if (!StrUtils.isEmpty(s.regions) && !StrUtils.isEmpty(regionCode) && s.regions.indexOf(regionCode) >= 0 &&
            job.carrierId > 0 && s.carrierId === job.carrierId &&
            s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('rc')) {
            conditionMap['rc'] = s
          }
        } else if (!StrUtils.isEmpty(s.regions) && !StrUtils.isEmpty(regionCode) && s.regions.indexOf(regionCode) >= 0 &&
            s.carrierId === 0 && s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('r')) {
            conditionMap['r'] = s
          }
        } else if (StrUtils.isEmpty(s.regions) && s.carrierId === 0 && s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('none')) {
            conditionMap['none'] = s
          }
        }
      } else {
        if (job.destinationAgent > 0 && s.destinationAgent === job.destinationAgent && job.carrierId > 0 && s.carrierId === job.carrierId) {
          if (!conditionMap.hasOwnProperty('dc')) {
            conditionMap['dc'] = s
          }
        } else if (job.destinationAgent > 0 && s.destinationAgent === job.destinationAgent && s.carrierId === 0) {
          if (!conditionMap.hasOwnProperty('d')) {
            conditionMap['d'] = s
          }
        } else if (job.carrierId > 0 && s.carrierId === job.carrierId && s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('c')) {
            conditionMap['c'] = s
          }
        } else if (s.carrierId === 0 && s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('none')) {
            conditionMap['none'] = s
          }
        }
      }
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('rcadc')) {
      airportRequirement = conditionMap['rcadc']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('rcad')) {
      airportRequirement = conditionMap['rcad']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('rcac')) {
      airportRequirement = conditionMap['rcac']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('rdc')) {
      airportRequirement = conditionMap['rdc']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('rca')) {
      airportRequirement = conditionMap['rca']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('rd')) {
      airportRequirement = conditionMap['rd']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('rc')) {
      airportRequirement = conditionMap['rc']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('dc')) {
      airportRequirement = conditionMap['dc']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('r')) {
      airportRequirement = conditionMap['r']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('d')) {
      airportRequirement = conditionMap['d']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('c')) {
      airportRequirement = conditionMap['c']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('none')) {
      airportRequirement = conditionMap['none']
    }
    return airportRequirement
  }
  static optionalSelect(list, job, regionCode, conditionMap) {
    list.sort((a, b) => {
      const suffixA = new Date(a.dateModified).getTime()
      const suffixB = new Date(b.dateModified).getTime()
      return suffixA - suffixB
    })
    let airportRequirement = null
    for (const s of list) {
      // 选填项（航线、船公司、目的港代理)
      // 如果港口要求中港口不为空则忽略航线。
      if (StrUtils.isEmpty(s.loadingPortCodes) && StrUtils.isEmpty(s.dischargingPortCodes) && StrUtils.isEmpty(s.destinationPortCodes)) {
        if (!StrUtils.isEmpty(s.regions) && s.regions.indexOf(regionCode) >= 0 &&
            job.destinationAgent > 0 && s.destinationAgent === job.destinationAgent &&
            job.carrierId > 0 && s.carrierId === job.carrierId) {
          if (!conditionMap.hasOwnProperty('rdc')) {
            conditionMap['rdc'] = s
          }
        } else if (!StrUtils.isEmpty(s.regions) && !StrUtils.isEmpty(regionCode) && s.regions.indexOf(regionCode) >= 0 &&
            job.destinationAgent > 0 && s.destinationAgent === job.destinationAgent &&
            s.carrierId === 0) {
          if (!conditionMap.hasOwnProperty('rd')) {
            conditionMap['rd'] = s
          }
        } else if (!StrUtils.isEmpty(s.regions) && !StrUtils.isEmpty(regionCode) && s.regions.indexOf(regionCode) >= 0 &&
            job.carrierId > 0 && s.carrierId === job.carrierId &&
            s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('rc')) {
            conditionMap['rc'] = s
          }
        } else if (!StrUtils.isEmpty(s.regions) && !StrUtils.isEmpty(regionCode) && s.regions.indexOf(regionCode) >= 0 &&
            s.carrierId === 0 && s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('r')) {
            conditionMap['r'] = s
          }
        } else if (StrUtils.isEmpty(s.regions) && s.carrierId === 0 && s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('none')) {
            conditionMap['none'] = s
          }
        }
      } else {
        if (job.destinationAgent > 0 && s.destinationAgent === job.destinationAgent && job.carrierId > 0 && s.carrierId === job.carrierId) {
          if (!conditionMap.hasOwnProperty('dc')) {
            conditionMap['dc'] = s
          }
        } else if (job.destinationAgent > 0 && s.destinationAgent === job.destinationAgent && s.carrierId === 0) {
          if (!conditionMap.hasOwnProperty('d')) {
            conditionMap['d'] = s
          }
        } else if (job.carrierId > 0 && s.carrierId === job.carrierId && s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('c')) {
            conditionMap['c'] = s
          }
        } else if (s.carrierId === 0 && s.destinationAgent === 0) {
          if (!conditionMap.hasOwnProperty('none')) {
            conditionMap['none'] = s
          }
        }
      }
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('rdc')) {
      airportRequirement = conditionMap['rdc']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('rd')) {
      airportRequirement = conditionMap['rd']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('rc')) {
      airportRequirement = conditionMap['rc']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('dc')) {
      airportRequirement = conditionMap['dc']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('r')) {
      airportRequirement = conditionMap['r']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('d')) {
      airportRequirement = conditionMap['d']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('c')) {
      airportRequirement = conditionMap['c']
    }
    if (!airportRequirement && conditionMap.hasOwnProperty('none')) {
      airportRequirement = conditionMap['none']
    }
    if (!airportRequirement) {
      airportRequirement = new AirPortRequirement().fillDefaultValue().getData()
    }
    return airportRequirement
  }

  static async getAirPortRequirementFileList(uuid) {
    if (!uuid) return []
    let files = []
    const xmlParam = '<RequestObject><data><extendMetaData><entry><key>uuid</key><value>' + uuid + '</value></entry></extendMetaData></data></RequestObject>'
    await getFileList(xmlParam).then(res => {
      files = Array.from(res.data, p => {
        return {
          fileId: p.id,
          fileName: p.fileName,
          fileType: p.fileType,
          fileSize: p.fileSize ? (Number(p.fileSize) / 1000 + 'KB') : '0KB'
        }
      })
    })
    return files
  }

  // 发货人选择
  static async shipperChangeFunc(form, data) {
    form.shipperId = data.value
    if (form.shipperId) {
      // 将收发通代码同步至提单页签收发通代码(不考虑拆并单)
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.shipperLine1 = manifestAddress.addressLine1
        form.shipperLine2 = manifestAddress.addressLine2
        form.shipperLine3 = manifestAddress.addressLine3
        form.shipperLine4 = manifestAddress.addressLine4
        form.shipperLine5 = manifestAddress.addressLine5
        form.shipperLine6 = manifestAddress.addressLine6
        form.shipperLine7 = manifestAddress.addressLine7
      } else {
        form.shipperLine1 = ''
        form.shipperLine2 = ''
        form.shipperLine3 = ''
        form.shipperLine4 = ''
        form.shipperLine5 = ''
        form.shipperLine6 = ''
        form.shipperLine7 = ''
      }
    }
  }
  // 收货人选择
  static async consigneeChangeFunc(form, data) {
    form.consigneeId = data.value
    if (form.consigneeId) {
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.consigneeLine1 = manifestAddress.addressLine1
        form.consigneeLine2 = manifestAddress.addressLine2
        form.consigneeLine3 = manifestAddress.addressLine3
        form.consigneeLine4 = manifestAddress.addressLine4
        form.consigneeLine5 = manifestAddress.addressLine5
        form.consigneeLine6 = manifestAddress.addressLine6
        form.consigneeLine7 = manifestAddress.addressLine7
      } else {
        form.consigneeLine1 = ''
        form.consigneeLine2 = ''
        form.consigneeLine3 = ''
        form.consigneeLine4 = ''
        form.consigneeLine5 = ''
        form.consigneeLine6 = ''
        form.consigneeLine7 = ''
      }
    }
  }
  // 通知人选择
  static async notifyChangeFunc(form, data) {
    form.notifyId = data.value
    if (form.notifyId) {
      const company = new Company(data)
      const manifestAddress = await company.getManifestAddress()
      if (manifestAddress) {
        form.notifyLine1 = manifestAddress.addressLine1
        form.notifyLine2 = manifestAddress.addressLine2
        form.notifyLine3 = manifestAddress.addressLine3
        form.notifyLine4 = manifestAddress.addressLine4
        form.notifyLine5 = manifestAddress.addressLine5
        form.notifyLine6 = manifestAddress.addressLine6
        form.notifyLine7 = manifestAddress.addressLine7
      } else {
        form.notifyLine1 = ''
        form.notifyLine2 = ''
        form.notifyLine3 = ''
        form.notifyLine4 = ''
        form.notifyLine5 = ''
        form.notifyLine6 = ''
        form.notifyLine7 = ''
      }
    }
  }
  // 目的港代理地址
  static async handingInfoTwoFunc(cmpIdx, handlingInfoConfig) {
    let handingInfoTwo = ''
    if (cmpIdx && cmpIdx > 0 && handlingInfoConfig.indexOf('2') !== -1) {
      const destinationAgent = await Company.getCompanyById(cmpIdx)
      const overseaAgent = destinationAgent ? await new Company(destinationAgent).getOverseaAgentDetail() : null
      if (overseaAgent) {
        if (overseaAgent.airAddressLine1) {
          if (handingInfoTwo) handingInfoTwo += '\n'
          handingInfoTwo += destinationAgent.overseaAgentDetail.airAddressLine1
        }
        if (overseaAgent.airAddressLine2) {
          if (handingInfoTwo) handingInfoTwo += '\n'
          handingInfoTwo += destinationAgent.overseaAgentDetail.airAddressLine2
        }
        if (overseaAgent.airAddressLine3) {
          if (handingInfoTwo) handingInfoTwo += '\n'
          handingInfoTwo += destinationAgent.overseaAgentDetail.airAddressLine3
        }
        if (overseaAgent.airAddressLine4) {
          if (handingInfoTwo) handingInfoTwo += '\n'
          handingInfoTwo += destinationAgent.overseaAgentDetail.airAddressLine4
        }
        if (overseaAgent.airAddressLine5) {
          if (handingInfoTwo) handingInfoTwo += '\n'
          handingInfoTwo += destinationAgent.overseaAgentDetail.airAddressLine5
        }
        if (overseaAgent.airAddressLine6) {
          if (handingInfoTwo) handingInfoTwo += '\n'
          handingInfoTwo += destinationAgent.overseaAgentDetail.airAddressLine6
        }
      }
    }
    return handingInfoTwo
  }
  /**
   * 同步英文品名
   * @param job
   * @param cargoDoc
   * @param action  0: 从基本同步到提单  其他：从提单同步到基本
   */
  static syncCargoEnglishName(job, cargoDoc, airCargoEnglishNameConfigValue = 0, action = 0) {
    if (!job || !cargoDoc || !airCargoEnglishNameConfigValue || ![1, 2].includes(airCargoEnglishNameConfigValue)) return
    if (action === 0) {
      cargoDoc.cargoEnglishName = job.cargoEnglishName
    } else {
      if (airCargoEnglishNameConfigValue === 2) { // 开启双向同步，HAWB,MAWB, 基本三个页签的品名要保持一致
        job.cargoEnglishName = cargoDoc.cargoEnglishName
        if (!job.masterFlag && job.airCargoDoc && job.airCargoDoc.length > 0) {
          for (const doc of job.airCargoDoc) {
            if (CargoDocConsts.HAWB === cargoDoc.docType) {
              if (CargoDocConsts.MAWB === doc.docType) {
                doc.cargoEnglishName = cargoDoc.cargoEnglishName
                break
              }
            }
            if (CargoDocConsts.MAWB === cargoDoc.docType) {
              if (CargoDocConsts.HAWB === doc.docType) {
                doc.cargoEnglishName = cargoDoc.cargoEnglishName
                break
              }
            }
          }
        }
      }
    }
  }
  /**
   * 同步唛头
   * @param job
   * @param cargoDoc
   * @param airCargoMarkConfig
   * @param action 0: 从基本同步到提单  其他：从提单同步到基本
   */
  static syncMark(job, cargoDoc, airCargoMarkConfigValue = 0, action = 0) {
    if (!job || !cargoDoc || !airCargoMarkConfigValue || ![1, 2].includes(airCargoMarkConfigValue)) return
    if (action === 0) {
      cargoDoc.remark1 = job.mark
    } else {
      if (airCargoMarkConfigValue === 2) { // 开启双向同步，HAWB,MAWB, 基本三个页签的唛头要保持一致
        job.mark = cargoDoc.remark1
        if (!job.masterFlag && job.airCargoDoc && job.airCargoDoc.length > 0) {
          for (const doc of job.airCargoDoc) {
            if (CargoDocConsts.HAWB === cargoDoc.docType) {
              if (CargoDocConsts.MAWB === doc.docType) {
                doc.remark1 = cargoDoc.remark1
                break
              }
            }
            if (CargoDocConsts.MAWB === cargoDoc.docType) {
              if (CargoDocConsts.HAWB === doc.docType) {
                doc.remark1 = cargoDoc.remark1
                break
              }
            }
          }
        }
      }
    }
  }
}
